import { create } from 'zustand'

export interface Message {
  id?: number
  role: 'user' | 'assistant'
  content: string
}

export interface Session {
  id: number
  category: string
  mode: string
  title: string | null
  created_at: string
  updated_at: string
}

interface CounselingState {
  sessions: Session[]
  currentSession: Session | null
  messages: Message[]
  streaming: boolean
  streamingContent: string
  setSessions: (sessions: Session[]) => void
  setCurrentSession: (session: Session | null) => void
  setMessages: (messages: Message[]) => void
  addMessage: (message: Message) => void
  setStreaming: (v: boolean) => void
  appendStreamingContent: (chunk: string) => void
  clearStreamingContent: () => void
}

export const useCounselingStore = create<CounselingState>((set) => ({
  sessions: [],
  currentSession: null,
  messages: [],
  streaming: false,
  streamingContent: '',
  setSessions: (sessions) => set({ sessions }),
  setCurrentSession: (session) => set({ currentSession: session, messages: [] }),
  setMessages: (messages) => set({ messages }),
  addMessage: (message) => set((s) => ({ messages: [...s.messages, message] })),
  setStreaming: (streaming) => set({ streaming }),
  appendStreamingContent: (chunk) => set((s) => ({ streamingContent: s.streamingContent + chunk })),
  clearStreamingContent: () => set({ streamingContent: '' }),
}))
